import React from "react";
import { useCountdown } from "../Countdown/countdown";
import "./OtpTimer.scss";

interface IOtpTimerProps {
  /** Total countdown length in seconds (constant for one run). */
  timer: number;
  /** Change to restart the countdown (e.g. on resend). */
  resetKey?: unknown;
  /** Called once when the countdown reaches 0. */
  onComplete?: () => void;
}

// Ring geometry (viewBox units): the ring scales with its container.
const RADIUS = 18;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/**
 * Countdown ring. Progress = remaining / total, driven by the shared
 * timestamp-based countdown: it drains linearly from full to empty and is
 * empty exactly when the number reaches 0.
 */
const OtpTimer: React.FC<IOtpTimerProps> = ({ timer, resetKey, onComplete }) => {
  const { secondsLeft, progress, transitionMs } = useCountdown(timer, { resetKey, onComplete });

  return (
    <div
      className="circular"
      role="timer"
      aria-live="off"
      aria-label={`${secondsLeft} seconds remaining`}
    >
      <svg className="ringSvg" viewBox="0 0 40 40" aria-hidden="true">
        <circle className="ringTrack" cx="20" cy="20" r={RADIUS} />
        <circle
          className="ringProgress"
          cx="20"
          cy="20"
          r={RADIUS}
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={CIRCUMFERENCE * (1 - progress)}
          style={{ transition: `stroke-dashoffset ${transitionMs}ms linear` }}
        />
      </svg>
      <div className="numb">{secondsLeft}</div>
    </div>
  );
};

export default OtpTimer;
